<template>
  <Banner
    :defaultBackground1="true"
    icon="person_outline"
    iconSize="36"
    data-testid="application-view-header-banner"
  >
    <template v-slot:title>
      <v-row>
        <v-col>
          <h1 class="appTitle">
            {{ getValue('application.client.firstName') }}
            {{ getValue('application.client.lastName') }}
            <ApplicationStatusChip small :status="getValue('applicationStatus')" />
          </h1>
        </v-col>
      </v-row>
    </template>
    <template v-slot:subtitle>
      <v-row :class="'pt-8 ml-n20'">
        <v-col class="pt-4" >
          <b>Application ID:</b><br/>{{getValue('applicationId') }}
        </v-col>
        <v-col
          class="pt-4"          
        >
        <b>Phone Number:</b>
         {{ getValue('application.client.phoneNumber') }}<br />
        <b>Email:</b>
        <a :href="`mailto:${getValue('application.client.email') }`" class="white--text">
              {{getValue('application.client.email')  }}
        </a>
        <br />          
        </v-col>
      </v-row>
    </template>
  </Banner>
</template>
<script>
import Banner from '@/components/app/Banner.vue' 
import fieldHelperMixin from '@/helpers/fieldHelperMixin'
import ApplicationStatusChip from '@/components/application/ApplicationStatusChip.vue'
import { numToOrdinal } from '@/helpers/generalUtils'
import { EA_STATUS } from '@/constants'

export default {
  name: 'ApplicationViewHeader',
  components: { Banner,  ApplicationStatusChip},
  mixins: [fieldHelperMixin],
  computed: {

  },
  methods: {
    getStatusText(status){
      return EA_STATUS[status]
    },
    getStatusChipProperties(status) {
      if (status === EA_STATUS.NEW) {
        return {
          outlined: true,
          //color: 'primary lighten-1' // blue-1
        }
      }

      if (status === EA_STATUS.REQ_APPROVED) {
        return {
          color: 'success',
          'text-color': 'white'
        }
      }

      if (status === EA_STATUS.APPROVAL_REQ_DENIED) {
        return {
          color: 'red base', // dark-60
          'text-color': 'white'
        }
      }

      return {
        // color: 'primary lighten-1', // blue-1
        'text-color': 'white'
      }
    },
  },
  filters: {
    ordinal: function(value) {
      return value ? numToOrdinal(value) : null
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .float-left {
  margin-left: 24px;
}
::v-deep .application-status {
  width: 142px;
  .v-chip__content span,
  .v-chip__content {
    width: 100%;
    text-align: center;
    font-weight: 700;
  }
}

.appTitle {
 font-size: 34px;
 margin-left: 19px;
 padding-top: 3px;
}

@include desktop { 
 .pagination {
    flex: 1;
    margin: 4rem 6rem 0 0;
 }
}

</style>